// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0098adef","617":"d32781fa","828":"a63b676d","849":"9275c38b"}[chunkId] + ".chunk.js";
};